import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import MaterialButton from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import axios from "axios";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import { ApiCall } from "./../../utility/ApiCalls";
import requests from "../../utility/Requests";
import { BasicTable } from "./Tables";
import { Button } from "./Button";
import "./../styles/DecisionBox.css";
import { enabled } from "ansi-colors";
import Api_Call from "../../ApiCall";
import UserContext from "../Common/UserContext";

export const DecisionBoxClinical = (props) => {
  const history = useHistory();
  const [btnDisplay, setDisplayReady] = useState("btn--hidden");
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [hipaa, setHIPAA] = React.useState("Validating");
  const [hipaaClass, setHIPAAClass] = React.useState("input-default");
  const [eligibility, setEligibility] = React.useState("Validating");
  const [eligibilityClass, setEligibilityClass] = useState("input-default");
  const [duplicateFound, setDuplicateFound] = React.useState("Validating");
  const [providerValidation, setProviderValidation] =
    React.useState("Validating");
  const [duplicateClass, setDuplicateClass] = React.useState("input-default");
  const [providerValidationClass, setProviderValidationClass] =
    React.useState("input-default");
  const [displayprocessrules, setDisplayprocessrules] = useState();
  const [ruleconsumer, setRuleconsumer] = useState([]);
  const [createAthResMsg, setCreateAthResMsg] = useState();
  const [indicateMsg, setIndicateMsg] = useState(false);
  const [noauthcpt, setNoauthcpt] = useState();
  const [saveDraftRes, setSaveDraftRes] = useState();
  const [validationPerformed, setValidationPerformed] = useState(true);
  const [auditLog, setAuditLog] = useState(false);
  const [caseactivityData, setCaseactivityData] = useState([]);
  const [validationPerformedData, setValidationPerformedData] = useState([]);
  const [startBtnDisabled, setStartBtnDisabled] = useState(false);
  const [validateTaskAgain, setValidateTaskAgain] = useState(false);
  const [disableStartProcessingBtn, setDisableStartProcessingBtn] =
    useState(false);
  const [saveClinicalRes, setsaveClinicalRes] = useState();
  const [selectedValidationValue, setSelectedValidationValue] = useState("");
  const [finalSubmit, setFinalSubmit] = useState("8");
  const [showButton, setShowButton] = useState(true);

  const { userId } = useContext(UserContext);

  const colums = [
    {
      width: 80,
      Header: "Timestamp",
      accessor: "CreateDate_DT",
    },
    {
      Header: "Activity",
      accessor: "Activity_CR",
    },
  ];

  async function autoProcessApi(taskId) {
    const api = new Api_Call();
    const data = await api.getData(
      `TASK/ACTIVITY-LOG?TaskID=${sessionStorage.getItem("ActiveTaskID")}`
    );
    const response = data.body;
    if (response) {
      setCaseactivityData(response);
    }

    // const ret = await ApiCall(
    //   {
    //     TaskID: window.sessionStorage.getItem("ActiveTaskID")
    //   },
    //   "vcare-ui",
    //   "vcare_caseactivity"
    // );
    // const response = ret.body;
    // if (response) {
    //   setCaseactivityData(response);
    // }
  }

  async function validationPerformedApi(taskId) {
    const api = new Api_Call();
    const data = await api.getData(
      `TASK/ACTIVITY-LOG?TaskID=${sessionStorage.getItem(
        "ActiveTaskID"
      )}&log_type=9`
    );
    const response = data.body;
    if (response) {
      setValidationPerformedData(response);
    }
    // const ret = await ApiCall(
    //   {
    //     TaskID: window.sessionStorage.getItem("ActiveTaskID"),
    //     log_type: 9
    //   },
    //   "vcare-ui",
    //   "vcare_caseactivity"
    // );
    // const response = ret.body;
    // if (response) {
    //   setValidationPerformedData(response);
    // }
  }

  const handleClickOpen = () => {
    setRuleconsumer([]);
    setDisableStartProcessingBtn(true);
    setStartBtnDisabled(true);
    setValidateTaskAgain(false);

    setHIPAA("Validating");
    setEligibility("Validating");
    setDuplicateFound("Validating");
    setProviderValidation("Validating");

    setHIPAAClass("input-default");
    setEligibilityClass("input-default");
    setDuplicateClass("input-default");
    setProviderValidationClass("input-default");
    setIndicateMsg(false);
    props.getOCRDatafromAPI().then((res) => {
      setValidateTaskAgain(res);
    });
    setOpen(true);
  };

  useEffect(() => {
    if (validateTaskAgain) {
      setRuleconsumer([]);
      DisplayprocessrulesAPI();
      HIPAAValidationfromAPI();
      EligibilityValidationfromAPI();
      DuplicateValidationfromAPI();
      ProviderValidationAPI();
      NoAuthCptAPI();
    }
  }, [validateTaskAgain]);

  const viewValidationPerformed = () => {
    setOpen2(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDisableStartProcessingBtn(false);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleCreateAuthOk = () => {
    history.push("/userHome");
  };

  async function DisplayprocessrulesAPI() {
    axios
      .post(requests.displayprocessrules_url, {
        taskID: sessionStorage.getItem("ActiveTaskID"),
        title: "Intake Validation",
      })
      .then((res) => {
        if (res) {
          setDisplayprocessrules(res.data.body);
          res.data.body.forEach((val) => {
            RuleconsumerAPI(val.RuleTitle_CR);
          });
        }
      });
  }

  async function RuleconsumerAPI(RuleTitle_CR) {
    var stringCPTCode = [];
    for (var x = 0; x < props.cptData.length; x++) {
      if (props.cptData.length == "1") {
        stringCPTCode = props.cptData[x].CPTCode_CR;
      } else {
        stringCPTCode.push(props.cptData[x].CPTCode_CR);
      }
    }
    var stringCPTUnits = "";
    for (var x = 0; x < props.cptData.length; x++) {
      stringCPTUnits = props.cptData[x].Unit_NR;
    }

    var stringDX = "";
    for (var x = 0; x < props.dxData.length; x++) {
      stringDX += props.dxData[x].DXCode_CR;
    }

    var stringProvider = "";
    for (var x = 0; x < props.providerData.length; x++) {
      stringProvider +=
        props.providerData[x].ProviderName +
        "|" +
        props.providerData[x].NPIID_CR +
        "|" +
        props.providerData[x].TaxID_CR +
        "|" +
        props.providerData[x].Address_CR +
        "|" +
        props.providerData[x].City_CR +
        "|" +
        props.providerData[x].State_CR +
        "|" +
        props.providerData[x].Zip_CR +
        "|" +
        props.providerData[x].PhoneNumber_CR +
        "|" +
        props.providerData[x].FaxNo_CR +
        "|" +
        props.providerData[x].ProviderType_CR;

      if (x != props.providerData.length - 1) {
        stringProvider += "^";
      }
    }
    axios
      .post(requests.ruleconsumer_url, {
        taskID: sessionStorage.getItem("ActiveTaskID"),
        module_name: "IntakeValidation.json",
        rule_file: RuleTitle_CR,
        CPTList: stringCPTCode,
        CPTUnits: stringCPTUnits.toString(),
        DXList: stringDX,
        ProviderList: stringProvider,
        ServiceRequestDate_DT: props.ocrData.ServiceRequestDate.value,
        MemberID_CR: props.ocrData.MemberID.value,
        FirstName_CR: props.ocrData.FirstName.value,
        LastName_CR: props.ocrData.LastName.value,
        DateOfBirth_DT: props.ocrData.DOB.value,
        ContactNo_CR: props.ocrData.Phone.value,
        RequestorName_CR: props.ocrData.RequestorName.value,
        RequestorContactNo_CR: props.ocrData.RequestorPhone.value,
        RequestorFaxNo_CR: props.ocrData.RequestorFax.value,
        AnticipatedStartDate_DT: props.ocrData.AnticipatedStartDate.value,
        AnticipatedEndtDate_DT: props.ocrData.AnticipatedEndDate.value,
        AdditionalMessage_CR: props.ocrData.AdditionalMessage.value,
        UMReviewType_CR: props.selectedUMreviewType,
        MemberAdmissionSource_CR: props.selectedAdmissionSource,
        MemberAdmissionType_CR: props.selectedAdmissionType,
      })
      .then((res) => {
        setRuleconsumer((prev) => {
          return [...prev, res.data];
        });
      });
  }

  async function HIPAAValidationfromAPI() {
    const api = new Api_Call();
    const data = await api.postData("VALIDATIONS/HIPAA", {
      taskID: sessionStorage.getItem("ActiveTaskID"),
      rule_file: "hipaa_updated.json",
      MemberID_CR: props.ocrData.MemberID.value,
      FirstName_CR: props.ocrData.FirstName.value,
      LastName_CR: props.ocrData.LastName.value,
      DateOfBirth_DT: props.ocrData.DOB.value,
    });
    const response = data.body;
    setHIPAA(response);
    if (response == "HIPAA successfully validated") {
      setHIPAAClass("input-yes");
    } else {
      setHIPAAClass("input-no");
    }

    // const ret = await ApiCall(
    //   {
    //     taskID: sessionStorage.getItem("ActiveTaskID"),
    //     rule_file: "hipaa_updated.json",
    //     MemberID_CR: props.ocrData.MemberID.value,
    //     FirstName_CR: props.ocrData.FirstName.value,
    //     LastName_CR: props.ocrData.LastName.value,
    //     DateOfBirth_DT: props.ocrData.DOB.value
    //   },
    //   "vcare-ui",
    //   "vcare_consumer_hipaavalidation"
    // );

    // const response = ret.body;
    // setHIPAA(response);
    // if (response == "HIPAA successfully validated") {
    //   setHIPAAClass("input-yes");
    // } else {
    //   setHIPAAClass("input-no");
    // }
  }

  async function EligibilityValidationfromAPI() {
    const api = new Api_Call();
    const data = await api.postData("VALIDATIONS/MEMBER-ELIGIBILITY", {
      taskID: sessionStorage.getItem("ActiveTaskID"),
      MemberID_CR: props.ocrData.MemberID.value,
      serviceDate: props.ocrData.ServiceRequestDate.value,
      FirstName_CR: props.ocrData.FirstName.value,
      LastName_CR: props.ocrData.LastName.value,
      DateOfBirth_DT: props.ocrData.DOB.value,
    });

    const response = data.body;
    setEligibility(response);
    if (response == "Member eligible") {
      setEligibilityClass("input-yes");
    } else {
      setEligibilityClass("input-no");
    }

    // const ret = await ApiCall(
    //   {
    //     taskID: sessionStorage.getItem("ActiveTaskID"),
    //     MemberID_CR: props.ocrData.MemberID.value,
    //     serviceDate: props.ocrData.ServiceRequestDate.value,
    //     FirstName_CR: props.ocrData.FirstName.value,
    //     LastName_CR: props.ocrData.LastName.value,
    //     DateOfBirth_DT: props.ocrData.DOB.value
    //   },
    //   "vcare-ui",
    //   "vcare_eligibilitycheck"
    // );

    // const response = ret.body;
    // setEligibility(response);
    // if (response == "Member eligible") {
    //   setEligibilityClass("input-yes");
    // } else {
    //   setEligibilityClass("input-no");
    // }
  }

  async function DuplicateValidationfromAPI() {
    console.log(
      "==================inside duplicate validation================"
    );
    var arrCPT = [];
    console.log(props.cptData);
    for (var x = 0; x < props.cptData.length; x++) {
      arrCPT.push(props.cptData[x].CPTCode_CR);
    }
    console.log("CPT codes for duplicate check ", props.ocrData.CPTCodes.value);
    const api = new Api_Call();
    const data = await api.postData("VALIDATIONS/DUPLICATE-CHECK", {
      taskID: sessionStorage.getItem("ActiveTaskID"),
      MemberID_CR: props.ocrData.MemberID.value,
      serviceDate: props.ocrData.ServiceRequestDate.value,
      // cptCode: props.ocrData.CPT.value
      CPT: props.ocrData.CPTCodes.value,
    });
    const response = data.body;
    setDuplicateFound(response);
    if (response == "Request is not duplicate") {
      setDuplicateClass("input-yes");
    } else {
      setDuplicateClass("input-no");
    }

    // var arrCPT = [];
    // for (var x = 0; x < props.cptData.length; x++) {
    //   arrCPT.push(props.cptData[x].CPTCode_CR);
    // }
    // const ret = await ApiCall(
    //   {
    //     taskID: sessionStorage.getItem("ActiveTaskID"),
    //     MemberID_CR: props.ocrData.MemberID.value,
    //     serviceDate: props.ocrData.ServiceRequestDate.value,
    //     //cptCode: props.ocrData.CPT.value
    //     CPT: props.ocrData.CPT.value
    //   },
    //   "vcare-ui",
    //   "vcare_duplicatecheck"
    // );

    // const response = ret.body;
    // setDuplicateFound(response);
    // if (response == "Request is not duplicate") {
    //   setDuplicateClass("input-yes");
    // } else {
    //   setDuplicateClass("input-no");
    // }
  }

  async function ProviderValidationAPI() {
    var stringProvider = "";
    for (var x = 0; x < props.providerData.length; x++) {
      stringProvider +=
        props.providerData[x].ProviderName +
        "|" +
        props.providerData[x].NPIID_CR +
        "|" +
        props.providerData[x].TaxID_CR +
        "|" +
        props.providerData[x].Address_CR +
        "|" +
        props.providerData[x].City_CR +
        "|" +
        props.providerData[x].State_CR +
        "|" +
        props.providerData[x].Zip_CR +
        "|" +
        props.providerData[x].PhoneNumber_CR +
        "|" +
        props.providerData[x].FaxNo_CR +
        "|" +
        props.providerData[x].ProviderType_CR;

      if (x != props.providerData.length - 1) {
        stringProvider += "^";
      }
    }

    console.log(stringProvider);
    const api = new Api_Call();
    const data = await api.postData("VALIDATIONS/PROVIDER-CHECK", {
      taskID: sessionStorage.getItem("ActiveTaskID"),
      ProviderList: stringProvider,
    });
    const response = data.body;
    setProviderValidation(response);
    if (response == "PAR") {
      setProviderValidationClass("input-yes");
    } else {
      setProviderValidationClass("input-no");
    }

    // const ret = await ApiCall(
    //   {
    //     taskID: sessionStorage.getItem("ActiveTaskID"),
    //     ProviderList: stringProvider
    //   },
    //   "vcare-ui",
    //   "vcare_providerparcheck"
    // );

    // const response = ret.body;
    // setProviderValidation(response);
    // if (response == "PAR") {
    //   setProviderValidationClass("input-yes");
    // } else {
    //   setProviderValidationClass("input-no");
    // }
  }

  async function NoAuthCptAPI() {
    // var stringCPTCode = "";
    var CPTList = [];
    for (var x = 0; x < props.cptData.length; x++) {
      //stringCPTCode = props.cptData[x].CPTCode_CR;
      CPTList.push(props.cptData[x].CPTCode_CR);
    }
    console.log("cptlist", CPTList);
    const api = new Api_Call();
    const data = await api.postData("VALIDATIONS/NOAUTH-CPT", {
      taskID: sessionStorage.getItem("ActiveTaskID"),
      CPT: CPTList,
      UICheck: "1",
    });

    const response = data.body;
    if (response) {
      setNoauthcpt(response);
    }

    // var CPTList = [];
    // for (var x = 0; x < props.cptData.length; x++) {
    //   //stringCPTCode = props.cptData[x].CPTCode_CR;
    //   CPTList.push(props.cptData[x].CPTCode_CR);
    // }
    // const ret = await ApiCall(
    //   {
    //     //CPT: stringCPTCode
    //     taskID: sessionStorage.getItem("ActiveTaskID"),
    //     CPT: CPTList,
    //     UICheck: "1"
    //   },
    //   "vcare-ui",
    //   "vcareui_noauthcpt"
    // );

    // const response = ret.body;
    // if (response) {
    //   setNoauthcpt(response);
    // }
  }

  async function submitUIData() {
    saveUIData(3);
    var stringCPT = "";
    for (var x = 0; x < props.cptData.length; x++) {
      stringCPT +=
        props.cptData[x].CPTCode_CR +
        "|" +
        props.cptData[x].Unit_NR +
        "|" +
        props.cptData[x].UnitDescription_CR +
        "|" +
        props.cptData[x].DescriptionText_CR;
      if (x != props.providerData.length - 1) {
        stringProvider += "^";
      }
    }
    var stringDX = "";
    for (var x = 0; x < props.dxData.length; x++) {
      stringDX +=
        props.dxData[x].DXCode_CR + "|" + props.dxData[x].DescriptionText_CR;
      if (x != props.providerData.length - 1) {
        stringProvider += "^";
      }
    }
    var stringProvider = "";
    for (var x = 0; x < props.providerData.length; x++) {
      stringProvider +=
        props.providerData[x].ProviderName +
        "|" +
        props.providerData[x].NPIID_CR +
        "|" +
        props.providerData[x].TaxID_CR +
        "|" +
        props.providerData[x].Address_CR +
        "|" +
        props.providerData[x].City_CR +
        "|" +
        props.providerData[x].State_CR +
        "|" +
        props.providerData[x].Zip_CR +
        "|" +
        props.providerData[x].PhoneNumber_CR +
        "|" +
        props.providerData[x].FaxNo_CR +
        "|" +
        props.providerData[x].ProviderType_CR;

      if (x != props.providerData.length - 1) {
        stringProvider += "^";
      }
    }
    const api = new Api_Call();
    const ret = await api.postData("TASK/AUTH", {
      auto_approval: "0",

      // Task_ID: sessionStorage.getItem("ActiveTaskID"),
      taskID: sessionStorage.getItem("ActiveTaskID"),

      Prioritization_CR: props.ocrData.Prioritization.value,

      CPTList: stringCPT,

      DXList: stringDX,

      ProviderList: stringProvider,

      OCRData_ID: props.ocrData.OCRData_ID,

      ServiceRequestDate_DT: props.ocrData.ServiceRequestDate.value,

      MemberID_CR: props.ocrData.MemberID.value,

      RequestorName_CR: props.ocrData.RequestorName.value,

      RequestorContactNo_CR: props.ocrData.RequestorPhone.value,

      RequestorFaxNo_CR: props.ocrData.RequestorFax.value,

      // AnticipatedStartDate_DT: props.ocrData.AnticipatedStartDate.value,
      serviceDate: props.ocrData.AnticipatedStartDate.value,

      AnticipatedEndtDate_DT: props.ocrData.AnticipatedEndDate.value,

      // UMReviewType_CR: props.selectedUMreviewType,

      UMReviewType_CR: props.ocrData.UMReviewType,

      MemberAdmissionSource_CR: props.selectedAdmissionSource,

      MemberAdmissionType_CR: props.selectedAdmissionType,

      PatientType_CR: props.ocrData.PatientType.value,

      RequestProfile_CR: props.ocrData.RequestProfile,
    });

    const response = ret.body.message;
    if (response) {
      setCreateAthResMsg(response);
    }

    // const ret = await ApiCall(
    //   {
    //     auto_approval: "0",

    //     Task_ID: sessionStorage.getItem("ActiveTaskID"),

    //     Prioritization_CR: props.ocrData.Prioritization.value,

    //     CPTList: stringCPT,

    //     DXList: stringDX,

    //     ProviderList: stringProvider,

    //     OCRData_ID: props.ocrData.OCRData_ID,

    //     ServiceRequestDate_DT: props.ocrData.ServiceRequestDate.value,

    //     MemberID_CR: props.ocrData.MemberID.value,

    //     RequestorName_CR: props.ocrData.RequestorName.value,

    //     RequestorContactNo_CR: props.ocrData.RequestorPhone.value,

    //     RequestorFaxNo_CR: props.ocrData.RequestorFax.value,

    //     AnticipatedStartDate_DT: props.ocrData.AnticipatedStartDate.value,

    //     AnticipatedEndtDate_DT: props.ocrData.AnticipatedEndDate.value,

    //     // UMReviewType_CR: props.selectedUMreviewType,

    //     UMReviewType_CR: props.ocrData.UMReviewType,

    //     MemberAdmissionSource_CR: props.selectedAdmissionSource,

    //     MemberAdmissionType_CR: props.selectedAdmissionType,

    //     PatientType_CR: props.ocrData.PatientType.value,

    //     RequestProfile_CR: props.ocrData.RequestProfile
    //   },
    //   "vcare-ui",
    //   "vcare_createauth"
    // );

    // const response = ret.body.message;
    // if (response) {
    //   setCreateAthResMsg(response);
    // }
  }

  function handleSubmit() {
    setStartBtnDisabled(true);
    submitUIData();
    setIndicateMsg(false);
    setDisableStartProcessingBtn(false);
  }

  useEffect(() => {
    if (
      hipaaClass == "input-no" ||
      eligibilityClass == "input-no" ||
      duplicateClass == "input-no" ||
      providerValidationClass == "input-no"
    ) {
      setIndicateMsg(true);
    }
    if (
      hipaa != "Validating" &&
      eligibility != "Validating" &&
      duplicateFound != "Validating" &&
      providerValidation != "Validating"
    ) {
      setStartBtnDisabled(false);
      setDisplayReady("btn--primary");
    }
  }, [
    hipaa,
    eligibility,
    duplicateFound,
    providerValidation,
    hipaaClass,
    eligibilityClass,
    duplicateClass,
    providerValidationClass,
  ]);

  useEffect(() => {
    autoProcessApi();
    validationPerformedApi();
  }, []);

  // var stringCPT = "";
  //   for (var x = 0; x < props.cptData.length; x++) {
  //     stringCPT +=
  //       props.cptData[x].CPTCode_CR +
  //       "|" +
  //       props.cptData[x].Unit_NR +
  //       "|" +
  //       props.cptData[x].UnitDescription_CR +
  //       "|" +
  //       props.cptData[x].DescriptionText_CR;
  //     if (x != props.cptData.length - 1) {
  //       stringCPT += "^";
  //     }
  //   }
  //   var stringDX = "";
  //   for (var x = 0; x < props.dxData.length; x++) {
  //     stringDX +=
  //       props.dxData[x].DXCode_CR + "|" + props.dxData[x].DescriptionText_CR;
  //     if (x != props.dxData.length - 1) {
  //       stringDX += "^";
  //     }
  //   }
  //   var stringProvider = "";
  //   for (var x = 0; x < props.providerData.length; x++) {
  //     stringProvider +=
  //       props.providerData[x].ProviderName +
  //       "|" +
  //       props.providerData[x].NPIID_CR +
  //       "|" +
  //       props.providerData[x].TaxID_CR +
  //       "|" +
  //       props.providerData[x].Address_CR +
  //       "|" +
  //       props.providerData[x].City_CR +
  //       "|" +
  //       props.providerData[x].State_CR +
  //       "|" +
  //       props.providerData[x].Zip_CR +
  //       "|" +
  //       props.providerData[x].PhoneNumber_CR +
  //       "|" +
  //       props.providerData[x].FaxNo_CR +
  //       "|" +
  //       props.providerData[x].ProviderType_CR;

  //     if (x != props.providerData.length - 1) {
  //       stringProvider += "^";
  //     }
  //   }

  //   console.log("stringCPT",stringCPT);
  //   console.log("stringCPT",stringDX)
  //   console.log("stringCPT",stringProvider)

  async function saveUIData(SaveType) {
    var stringCPT = "";
    for (var x = 0; x < props.cptData.length; x++) {
      stringCPT +=
        props.cptData[x].CPTCode_CR +
        "|" +
        props.cptData[x].Unit_NR +
        "|" +
        props.cptData[x].UnitDescription_CR +
        "|" +
        props.cptData[x].DescriptionText_CR;
      if (x != props.cptData.length - 1) {
        stringCPT += "^";
      }
    }
    var stringDX = "";
    for (var x = 0; x < props.dxData.length; x++) {
      stringDX +=
        props.dxData[x].DXCode_CR + "|" + props.dxData[x].DescriptionText_CR;
      if (x != props.dxData.length - 1) {
        stringDX += "^";
      }
    }
    var stringProvider = "";
    for (var x = 0; x < props.providerData.length; x++) {
      stringProvider +=
        props.providerData[x].ProviderName +
        "|" +
        props.providerData[x].NPIID_CR +
        "|" +
        props.providerData[x].TaxID_CR +
        "|" +
        props.providerData[x].Address_CR +
        "|" +
        props.providerData[x].City_CR +
        "|" +
        props.providerData[x].State_CR +
        "|" +
        props.providerData[x].Zip_CR +
        "|" +
        props.providerData[x].PhoneNumber_CR +
        "|" +
        props.providerData[x].FaxNo_CR +
        "|" +
        props.providerData[x].ProviderType_CR;

      if (x != props.providerData.length - 1) {
        stringProvider += "^";
      }
    }
    const ret = await ApiCall(
      {
        SaveType: SaveType,

        Task_ID: sessionStorage.getItem("ActiveTaskID"),

        CPTList: stringCPT,

        DXList: stringDX,

        ProviderList: stringProvider,

        User_ID: sessionStorage.getItem("UserID"),

        OCRData_ID: props.ocrData.OCRData_ID,

        Fax_ID: props.ocrData.Fax_ID,

        Prioritization_CR: props.ocrData.Prioritization.value,

        MemberID_CR: props.ocrData.MemberID.value,

        FirstName_CR: props.ocrData.FirstName.value,

        LastName_CR: props.ocrData.LastName.value,

        DateOfBirth_DT: props.ocrData.DOB.value,

        RequestorName_CR: props.ocrData.RequestorName.value,

        RequestorContactNo_CR: props.ocrData.RequestorPhone.value,

        RequestorFaxNo_CR: props.ocrData.RequestorFax.value,

        AdditionalMessage_CR: props.ocrData.AdditionalMessage.value,

        ServiceRequestDate_DT: props.ocrData.ServiceRequestDate.value,

        AnticipatedStartDate_DT: props.ocrData.AnticipatedStartDate.value,

        AnticipatedEndtDate_DT: props.ocrData.AnticipatedEndDate.value,

        ContactNo_CR: props.ocrData.Phone.value,

        PatientType_CR: props.ocrData.PatientType.value,

        // UMReviewType_CR: props.selectedUMreviewType,

        UMReviewType_CR: props.ocrData.UMReviewType,

        MemberAdmissionSource_CR: props.selectedAdmissionSource,

        MemberAdmissionType_CR: props.selectedAdmissionType,

        RequestProfile_CR: props.ocrData.RequestProfile,

        isClinicalsFound_YN: "",

        isMultipleMember_YN: props.ocrData.isMultipleMember,

        FormType_CR: "Prior Auth",

        CreatedByID_NR: sessionStorage.getItem("UserID"),

        ModifiedByID_NR: sessionStorage.getItem("UserID"),
      },

      "vcare-ui",
      "vcare_uidata"
    );

    const response = ret.body;
    if (response) {
      setSaveDraftRes(response);
    }
  }
  const saveUIDataFunc = () => {
    saveUIData(2);
    setTimeout(() => {
      toast.success(saveDraftRes);
      // history.push("/userHome");
    }, 2000);
  };

  const handleClinicalSaveOk = () => {
    console.log("Inside the final ok");
    history.push("/ClinicalHome");
  };

  // async function saveClinicalUIData(SaveType, SelectedValue) {
  //   console.log("value of save type ", SaveType);
  //   const api = new Api_Call();
  //   const data = await api.postData("CLINICAL-REVIEW/SUBMIT", {
  //     SaveType: SaveType,
  //     SelectedValue: SelectedValue,
  //     Task_ID: sessionStorage.getItem("ActiveTaskID"),
  //     user_id: userId,
  //   });
  //   const response = data.body;
  //   if (response) {
  //     setsaveClinicalRes(response);
  //   }

  //   // const ret = await ApiCall(
  //   //   {
  //   //     SaveType: SaveType,
  //   //     SelectedValue: SelectedValue,
  //   //     Task_ID: sessionStorage.getItem("ActiveTaskID"),
  //   //   },
  //   //   "vcare-ui",
  //   //   "vcareui_submitclinicalcase"
  //   // );

  //   // const response = ret.body;
  //   // if (response) {
  //   //     setsaveClinicalRes(response);
  //   // }
  // }
  console.log("save type task to", selectedValidationValue);
  console.log("save type refer to", finalSubmit);
  console.log("selected value", props.selectedDecisionValue);
  // const submitClinical = () => {
  //   //saveClinicalUIData(7);
  //   saveClinicalUIData(finalSubmit, props.selectedDecisionValue);
  //   //console.log(saveClinicalRes);
  //   toast.success(saveClinicalRes);
  //   history.push("/ClinicalHome");
  //   // setTimeout(() => {
  //   //     toast.success(saveDraftRes);
  //   //     // history.push("/userHome");
  //   //   }, 2000);
  // };

  // const submitValidations = () => {
  //   if (selectedValidationValue == "7") {
  //     saveClinicalUIData(selectedValidationValue);
  //   }
  //   toast.success(saveClinicalRes);
  //   history.push("/ClinicalHome");
  // };

  // const validationPerformedClick = () => {
  //   setAuditLog(false);
  //   setValidationPerformed(true);
  // };
  // const auditLogClick = () => {
  //   setValidationPerformed(false);
  //   setAuditLog(true);
  // };

  // useEffect(() => {
  //   console.log(props.selectedDecisionValue);
  //   if (props.selectedDecisionValue == 3) {
  //     console.log(props.selectedDecisionValue);
  //     setFinalSubmit("7");
  //   }
  // }, [props.selectedDecisionValue]);
  async function saveClinicalUIData(SaveType, SelectedValue) {
    console.log("value of save type ", SaveType);
    const api = new Api_Call();
    const data = await api.postData("CLINICAL-REVIEW/SUBMIT", {
      SaveType: SaveType,
      SelectedValue: SelectedValue,
      Task_ID: sessionStorage.getItem("ActiveTaskID"),
      user_id: userId,
    });
    // const ret = await ApiCall(
    //   {
    //     SaveType: SaveType,
    //     SelectedValue: SelectedValue,
    //     Task_ID: sessionStorage.getItem("ActiveTaskID"),
    //   },
    //   "vcare-ui",
    //   "vcareui_submitclinicalcase"
    // );

    const response = data.body;
    if (response) {
      setsaveClinicalRes(response);
    }
  }
  const submitClinical = () => {
    //saveClinicalUIData(7);
    saveClinicalUIData(finalSubmit, props.selectedDecisionValue);
    //console.log(saveClinicalRes);
    toast.success(saveClinicalRes);
    history.push("/ClinicalHome");
    // setTimeout(() => {
    //     toast.success(saveDraftRes);
    //     // history.push("/userHome");
    //   }, 2000);
  };

  const submitValidations = () => {
    if (selectedValidationValue == "7") {
      saveClinicalUIData(selectedValidationValue, props.selectedDecisionValue);
    }
    toast.success(saveClinicalRes);
    history.push("/ClinicalHome");
  };

  const validationPerformedClick = () => {
    setAuditLog(false);
    setValidationPerformed(true);
  };
  const auditLogClick = () => {
    setValidationPerformed(false);
    setAuditLog(true);
  };

  useEffect(() => {
    console.log(props.selectedDecisionValue);
    if (props.selectedDecisionValue == 3) {
      console.log(props.selectedDecisionValue);
      setFinalSubmit("9");
    }
    if (props.selectedDecisionValue == 2) {
      console.log(props.selectedDecisionValue);
      setFinalSubmit("8");
    }
  }, [props.selectedDecisionValue]);
  console.log(finalSubmit);

  console.log("-->", props.notDisplay);
  if (props.notDisplay === "") {
    return <></>;
  }

  return (
    <div className="decisionCB">
      <div className="save-button-list">
        {props.dataStatus ? (
          props.taskStatus != 7 &&
          props.taskStatus != 8 &&
          props.taskStatus != 19 &&
          props.tabDetail.validations != "none" ? (
            <>
              <div className="field-label-clinical">
                {/* <label>Refer to MD</label> </div> */}
                <label>Task to Intake Team</label>{" "}
              </div>
              <div className="field-text-clinical">
                <select
                  onChange={(e) => setSelectedValidationValue(e.target.value)}
                >
                  <option value="7">Yes</option>
                  <option value="10" selected>
                    No
                  </option>
                </select>
              </div>
              {/* <h4>{selectedValidationValue}</h4> */}
              {selectedValidationValue == "7" ? (
                <Button
                  buttonStyle="btn--outline"
                  onClick={submitValidations}
                  style={{ display: "none" }}
                >
                  {/* onClick={saveUIDataFunc}> */}
                  Submit
                </Button>
              ) : (
                ""
              )}
            </>
          ) : props.taskStatus != 7 &&
            props.taskStatus != 8 &&
            props.taskStatus != 19 &&
            props.tabDetail.guidelineSummary != "none" ? (
            <>
              <div className="field-label-clinical">
                <label>Refer to MD</label>{" "}
              </div>
              <div className="field-text-clinical">
                <select
                  value={finalSubmit}
                  onChange={(e) => setFinalSubmit(e.target.value)}
                >
                  <option value="9">Yes</option>
                  <option value="8" selected>
                    No
                  </option>
                </select>
              </div>
              <Button buttonStyle="btn--outline" onClick={submitClinical}>
                {/* onClick={saveUIDataFunc}> */}
                Submit
              </Button>
            </>
          ) : props.taskStatus != 7 &&
            props.taskStatus != 8 &&
            props.taskStatus != 19 &&
            props.tabDetail.intake != "none" ? (
            ""
          ) : (
            <Button
              buttonStyle="btn--outline"
              onClick={viewValidationPerformed}
            >
              View Validations Performed
            </Button>
          )
        ) : (
          ""
        )}
      </div>

      <Dialog open={open} onClose={handleClose} className="validation-dialog">
        {createAthResMsg ? (
          <>
            <Typography variant="h5" className="createAthResMsg">
              {createAthResMsg}
            </Typography>
          </>
        ) : (
          <>
            <DialogTitle>Validation Result</DialogTitle>
            <DialogContent style={{ color: "#fb4e0b" }}>
              <DialogContentText> HIPAA Passed? </DialogContentText>
              {hipaa === "Validating" ? (
                <LinearProgress
                  color="inherit"
                  sx={{ height: 20, m: 1, borderRadius: 2 }}
                />
              ) : (
                <input readOnly value={hipaa} className={hipaaClass}></input>
              )}
              <DialogContentText> is Member Eligible? </DialogContentText>
              {eligibility === "Validating" ? (
                <LinearProgress
                  color="inherit"
                  sx={{ height: 20, m: 1, borderRadius: 2 }}
                />
              ) : (
                <input
                  readOnly
                  value={eligibility}
                  className={eligibilityClass}
                ></input>
              )}

              <DialogContentText> Duplicate Request? </DialogContentText>
              {duplicateFound === "Validating" ? (
                <LinearProgress
                  color="inherit"
                  sx={{ height: 20, m: 1, borderRadius: 2 }}
                />
              ) : (
                <input
                  readOnly
                  value={duplicateFound}
                  className={duplicateClass}
                ></input>
              )}
              <DialogContentText>Provider Network?</DialogContentText>
              {providerValidation === "Validating" ? (
                <LinearProgress
                  color="inherit"
                  sx={{ height: 20, m: 1, borderRadius: 2 }}
                />
              ) : (
                <input
                  readOnly
                  value={providerValidation}
                  className={providerValidationClass}
                ></input>
              )}

              {displayprocessrules
                ? displayprocessrules.map((val, i) => {
                    return (
                      <>
                        <DialogContentText>{val.Step_Title}</DialogContentText>
                        <>
                          {ruleconsumer.length === 0 ? (
                            <LinearProgress
                              color="inherit"
                              sx={{ height: 20, m: 1, borderRadius: 2 }}
                            />
                          ) : ruleconsumer ? (
                            ruleconsumer.map((val2, index) => (
                              <>
                                {val2.headers.rule_file == val.RuleTitle_CR ? (
                                  <>
                                    <input
                                      readOnly
                                      value={val2.body}
                                      className={
                                        val2.headers.success
                                          ? "input-yes"
                                          : "input-no"
                                      }
                                    ></input>
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            ))
                          ) : (
                            ""
                          )}
                        </>
                      </>
                    );
                  })
                : ""}

              {indicateMsg ? (
                <Typography
                  className="validate-indicate-message"
                  style={{ color: "red" }}
                >
                  There were errors noted while processing case. Case routed to
                  exception queue for review.
                  {/* There were errors would you like to continue to create auth,
                  please confirm. */}
                </Typography>
              ) : (
                ""
              )}
              {noauthcpt ? (
                <Typography
                  className="validate-indicate-message"
                  style={{ color: "#008000" }}
                >
                  {noauthcpt}
                </Typography>
              ) : (
                ""
              )}
            </DialogContent>
          </>
        )}

        {createAthResMsg ? (
          <>
            <DialogActions className="text-center">
              <Button onClick={handleCreateAuthOk}>OK</Button>
            </DialogActions>{" "}
          </>
        ) : (
          <DialogActions>
            <MaterialButton
              variant="contained"
              className="materialButton"
              onClick={handleSubmit}
              disabled={startBtnDisabled}
            >
              Submit
            </MaterialButton>
            <MaterialButton
              variant="contained"
              className="materialButton"
              onClick={handleClose}
            >
              Cancel
            </MaterialButton>
          </DialogActions>
        )}
      </Dialog>

      <Dialog open={open2} onClose={handleClose2} className="validation-dialog">
        <DialogTitle>View Validations Performed</DialogTitle>
        <DialogContent>
          <Stack direction="row" className="view-validation-performed-tabs">
            <Button
              buttonStyle={
                validationPerformed ? "btn--primary" : "btn--outline"
              }
              onClick={validationPerformedClick}
            >
              Business Validations Performed
            </Button>
            <Button
              buttonStyle={auditLog ? "btn--primary" : "btn--outline"}
              onClick={auditLogClick}
            >
              Audit Logs
            </Button>
          </Stack>

          <Box className="validation-performed-content">
            {validationPerformed ? (
              <Box className="validation-performed">
                <ul>
                  {validationPerformedData
                    ? validationPerformedData.map((val) =>
                        val.log_type == 1 ? (
                          <li>
                            <span>
                              <CheckCircleOutlinedIcon className="success" />
                            </span>{" "}
                            <span>{val.Activity_CR}</span>
                          </li>
                        ) : (
                          <li>
                            <span>
                              <HighlightOffIcon className="error" />
                            </span>{" "}
                            <span>{val.Activity_CR}</span>
                          </li>
                        )
                      )
                    : ""}
                </ul>
              </Box>
            ) : (
              ""
            )}
            {auditLog ? (
              <Box className="audit-log tasklist-table audit-log-table">
                <BasicTable
                  columns={colums}
                  tableData={caseactivityData}
                  tableType="default"
                />
              </Box>
            ) : (
              ""
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose2}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
